'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

const IconAlert = icons_Icon.iconFactory('IconAlert', jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M13.5,15 L10.5,15 L10.5,18 L13.5,18 L13.5,15 Z M13.5,6 L10.5,6 L10.5,13.5 L13.5,13.5 L13.5,6 Z" }) }));

exports.IconAlert = IconAlert;
//# sourceMappingURL=IconAlert.js.map
